<div class="topbar-row pl-xl pr-xl disp-f a-i-c j-c-sb mt-l">
  <div class="header-left flex-align-center gap-M">
    @if (layout.isHandset()) {
      <button class="mobile-burger flex-center" type="button" (click)="menuState.toggleMobileMenu()"
        [attr.aria-label]="'menu.unfold' | translate" [title]="'menu.unfold' | translate">
        <img src="assets/icons/burger-menu.svg" alt="" class="icon-18 filter-darkgrey">
      </button>
    }
    @if (icon() && title()) {
      <div class="header-icon-card flex-center">
        <img [src]="'assets/icons/menu/' + icon() + '.svg'" alt="" class="icon-18 filter-darkgrey">
      </div>
    }
    <div class="flex-column header-titles">
      @if (title()) {
        <div class="header-title-row gap-S">
          <span class="header-title primary">{{ title() | translate }}</span>
          @if (indicator()) {
            <div class="header-indicator flex-center border-primary primary">
              {{ indicator() }}
            </div>
          }
        </div>
      }
      @if (subtitle()) {
        <div class="header-subtitle">
          {{ subtitle() | translate }}
        </div>
      }
    </div>
  </div>
  @if (layout.isHandset()) {
    <!-- Barre compacte téléphone : recherche globale + avatar (Mon compte) à droite,
         à la place du logo — l'accès au menu reste le burger à gauche. -->
    <div class="mobile-actions flex-align-center gap-XS">
      <app-trial-badge></app-trial-badge>
      <!-- Espace suspendu : la recherche ne mènerait qu'à des pages verrouillées (KAB-2399). -->
      @if (!suspended()) {
        <button class="mobile-icon-button flex-center" type="button" (click)="research.toggle()"
          [attr.aria-label]="'menu.research' | translate" [title]="'menu.research' | translate">
          <img src="assets/icons/search-md.svg" alt="" class="filter-darkgrey">
        </button>
      }
      <!-- Même carte profil que la rangée utilisateur du menu (Mon compte / Se déconnecter). -->
      <div class="mobile-avatar-wrap">
        <button class="mobile-avatar-button flex-center" type="button" [dropdownTrigger]="userMenu"
          [attr.aria-label]="'menu.account' | translate" [title]="'menu.account' | translate">
          <app-display-user-logo [user]="currentUser()" [size]="32"></app-display-user-logo>
        </button>
        <app-dropdown #userMenu class="topbar-user-dropdown" [paddingX]="10" [paddingY]="10" [radius]="15" [minimumMargin]="8">
          <app-user-menu-card (closed)="userMenu.close()"></app-user-menu-card>
        </app-dropdown>
      </div>
    </div>
  } @else {
    <div class="flex-align-center gap-M">
      <app-members-activity></app-members-activity>
      <app-trial-badge></app-trial-badge>
    </div>
  }
</div>
